import { EmoteStreamType } from './redux/types';
export const streamTypeToSearchType = {
    [EmoteStreamType.OFFICIAL]: 'community',
    [EmoteStreamType.COMMUNITY]: 'community',
    [EmoteStreamType.USER]: 'user'
};

//# sourceMappingURL=constants.js.map